const storageKey = 'gr:recent-products:v1';
const maxAge = 30 * 86400000;
class GrRecentlyViewed extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    let history = [];
    try {
      let stored = [];
      try { stored = JSON.parse(localStorage.getItem(storageKey) || '[]'); } catch { /* Reset invalid history. */ }
      if (Array.isArray(stored)) history = stored.filter(item => item && typeof item.handle === 'string' && /^[a-z0-9-]+$/.test(item.handle) && /^\d+$/.test(String(item.id)) && Number.isFinite(item.time) && item.time > Date.now() - maxAge && item.time <= Date.now()).slice(0, 12);
      const seen = new Set();
      history = history.filter(item => !seen.has(String(item.id)) && seen.add(String(item.id)));
      this.items = history.filter(item => String(item.id) !== this.dataset.productId).slice(0, 4);
      if (this.dataset.productHandle && this.dataset.productId) {
        const current = {handle:this.dataset.productHandle, id:this.dataset.productId, time:Date.now()};
        localStorage.setItem(storageKey, JSON.stringify([current, ...history.filter(item => String(item.id) !== current.id)].slice(0, 12)));
      }
    } catch { this.items = []; }
    if (!this.items.length) return;
    this.hidden = false;
    this.querySelector('button').addEventListener('click', () => {
      try { localStorage.removeItem(storageKey); } catch { /* Storage may be unavailable. */ }
      this.controller?.abort();
      this.observer?.disconnect();
      const heading = document.querySelector('h1');
      if (heading) { heading.setAttribute('tabindex','-1'); heading.focus({preventScroll:true}); }
      this.hidden = true;
    });
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) { this.observer.disconnect(); this.load(); }
      }, {rootMargin:'600px 0px'});
      this.observer.observe(this);
    } else this.load();
  }
  async load() {
    this.controller = new AbortController();
    const root = (this.dataset.root || '/').replace(/\/$/, '');
    const results = await Promise.allSettled(this.items.map(async item => {
      const url = `${root}/products/${encodeURIComponent(item.handle)}?section_id=gr-recent-product-card`;
      const response = await fetch(url,{signal:this.controller.signal,credentials:'same-origin'});
      if (!response.ok) return null;
      const doc = new DOMParser().parseFromString(await response.text(),'text/html');
      const card = doc.querySelector('[data-recent-product-id]');
      return card?.dataset.recentProductId === String(item.id) ? card : null;
    }));
    if (!this.isConnected || this.controller.signal.aborted) return;
    const cards = results.filter(result => result.status === 'fulfilled' && result.value).map(result => result.value);
    this.querySelector('[data-recent-items]').replaceChildren(...cards);
    if (!cards.length) this.hidden = true;
  }
  disconnectedCallback() { this.observer?.disconnect(); this.controller?.abort(); }
}
if (!customElements.get('gr-recently-viewed')) customElements.define('gr-recently-viewed',GrRecentlyViewed);
